// move-atc-sticky.js
(function () {
  // Config: selectors commonly used by Impulse and other themes
  const formSelector = 'product-form, form[action*="/cart/add"], form[action*="/products/"]';
  const controlsSelectors = [
    '.product-form__controls',     // Impulse common
    '.product__submit',
    '.buy-buttons',
    '.product-form__buttons',
    '.element-button-group'
  ];

  // Minimum viewport width to treat as "desktop". We show sticky primarily for mobile but can enable for all.
  const MOBILE_MAX = 9999; // set to 680 if you only want on mobile. Using large value will apply to all viewports.

  function findProductForm() {
    // prefer <product-form> wrapper if exists, otherwise find form element
    const pf = document.querySelector('product-form');
    if (pf) {
      // product-form custom element contains a <form> - find the inner form
      return pf.querySelector('form') || pf;
    }
    return document.querySelector('form[action*="/cart/add"], form[action*="/products/"]');
  }

  function findControls(form) {
    for (const sel of controlsSelectors) {
      const el = form.querySelector(sel);
      if (el) return el;
    }
    // fallback: find any submit button and use its parent
    const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
    if (submitBtn) {
      return submitBtn.closest('div') || submitBtn.parentElement;
    }
    return null;
  }

  function createStickyWrapper(form) {
    // If it already exists inside this form, return it
    let wrapper = form.querySelector('#sticky-existing-atc');
    if (wrapper) return wrapper;

    wrapper = document.createElement('div');
    wrapper.id = 'sticky-existing-atc';
    // Insert wrapper as last child of form so it remains inside the form DOM
    form.appendChild(wrapper);
    return wrapper;
  }

  function moveControlsIntoSticky(form) {
    const controls = findControls(form);
    if (!controls) return false;

    const wrapper = createStickyWrapper(form);

    // If controls already inside wrapper — nothing to do
    if (wrapper.contains(controls)) return true;

    // Save a hidden placeholder to restore to original position later, if needed
    if (!controls.dataset.originalParent) {
      const placeholder = document.createComment('original-controls-placeholder');
      controls.parentNode.insertBefore(placeholder, controls);
      controls.dataset.originalParent = true; // flag
      controls.dataset._placeholder = placeholder; // not serializable, but saved for session
      // store reference in window map
      (window._ATC_PLACEHOLDERS = window._ATC_PLACEHOLDERS || []).push({controls: controls, placeholder: placeholder});
    }

    // Move the controls element into wrapper
    wrapper.appendChild(controls);
    // Mark the body so we can add bottom padding to avoid overlap
    document.body.classList.add('has-sticky-atc');
    return true;
  }

  function restoreControls(form) {
    // Find moved pairs from window map and restore if present
    if (!window._ATC_PLACEHOLDERS) return;
    for (const rec of window._ATC_PLACEHOLDERS.slice()) {
      const controls = rec.controls;
      const placeholder = rec.placeholder;
      if (!controls || !placeholder) continue;
      if (placeholder.parentNode) {
        placeholder.parentNode.insertBefore(controls, placeholder);
        placeholder.parentNode.removeChild(placeholder);
      } else {
        // fallback: append back to form
        form.appendChild(controls);
      }
      // remove wrapper if empty
      const wrapper = form.querySelector('#sticky-existing-atc');
      if (wrapper && wrapper.children.length === 0) wrapper.remove();
      document.body.classList.remove('has-sticky-atc');
    }
    window._ATC_PLACEHOLDERS = [];
  }

  function shouldUseSticky() {
    // example: show sticky on small viewports only:
    // return window.innerWidth <= 680;
    // but you asked to reuse existing buttons like nobero — show on all viewports:
    return window.innerWidth <= MOBILE_MAX;
  }

  function initOnce() {
    const form = findProductForm();
    if (!form) return;

    // If product template loads new variants dynamically, observe changes
    const apply = () => {
      if (shouldUseSticky()) {
        moveControlsIntoSticky(form);
      } else {
        restoreControls(form);
      }
    };

    apply();

    // Reapply when window resizes (desktop ↔ mobile)
    let resizeTimer;
    window.addEventListener('resize', () => {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(apply, 160);
    });

    // Observe DOM changes inside the form (some themes re-render buttons)
    try {
      const mo = new MutationObserver(() => {
        // small debounce
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(apply, 120);
      });
      mo.observe(form, { childList: true, subtree: true });
    } catch (e) {
      console.warn('sticky ATC: mutation observer failed', e);
    }
  }

  // Run after DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOnce);
  } else {
    initOnce();
  }
})();